import { render, staticRenderFns } from "./ColorInputField.vue?vue&type=template&id=401f46c3&scoped=true"
import script from "./ColorInputField.vue?vue&type=script&lang=js"
export * from "./ColorInputField.vue?vue&type=script&lang=js"
import style0 from "./ColorInputField.vue?vue&type=style&index=0&id=401f46c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f46c3",
  null
  
)

export default component.exports